import { Severity } from '../../shared/enums/severity';

export class ApiMessage {
  text: string;
  severity: Severity;
  localizationKey: string;

  public loadFromJson(data) {
    this.text = data.text;
    this.severity = data.severity;
    if(data.localizationKey != null) {
      this.localizationKey = data.localizationKey;
    }
  }
}
